/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDto } from '../../models/file-dto';

export interface StorageControllerDeleteFileV1$Params {

/**
 * 파일 URL
 */
  url: string;
}

export function storageControllerDeleteFileV1(http: HttpClient, rootUrl: string, params: StorageControllerDeleteFileV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDto>> {
  const rb = new RequestBuilder(rootUrl, storageControllerDeleteFileV1.PATH, 'delete');
  if (params) {
    rb.path('url', params.url, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileDto>;
    })
  );
}

storageControllerDeleteFileV1.PATH = '/api/v1/storage/{url}';
